module.exports = __webpack_public_path__ + "img/pagel.ec87b814.png";